import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { CustomButton } from 'src/components/button/Button';
import { lang } from 'src/utils';

import { FooterProps } from './Footer.interface';
import { BackButton, FooterActions, FooterContainer } from './Footer.styled';

export const Footer = (props: FooterProps) => {
  const {
    hasSubNav,
    showFooterActions,
    disableCancel,
    disableSave,
    backLabel,
    cancelLabel,
    saveLabel,
    showArrow = false,
    cancelButtonColor,
    backButtonProps = {},
    cancelButtonProps = {},
    saveButtonProps = {},
    hideBackButton,
    isSaving,
    onBack,
    onCancel,
    onSave,
  } = props;

  return (
    <FooterContainer $hasSubNav={hasSubNav}>
      {showFooterActions && (
        <FooterActions>
          {!hideBackButton && (
            <>
              {onBack && (
                <BackButton
                  variant="outlined"
                  {...(showArrow && { startIcon: <KeyboardArrowLeft /> })}
                  onClick={onBack}
                  {...backButtonProps}>
                  {backLabel || lang.back}
                </BackButton>
              )}
            </>
          )}

          <CustomButton
            variant="text"
            onClick={onCancel}
            disabled={disableCancel}
            btnColor={cancelButtonColor}
            {...cancelButtonProps}>
            {cancelLabel || lang.cancel}
          </CustomButton>

          <LoadingButton
            variant="contained"
            {...(showArrow && { endIcon: <KeyboardArrowRight /> })}
            onClick={onSave}
            disabled={disableSave}
            loading={isSaving}
            {...saveButtonProps}>
            {saveLabel || lang.save}
          </LoadingButton>
        </FooterActions>
      )}
    </FooterContainer>
  );
};
